import {NgModule} from '@angular/core';
import {LibGroupInputComponent} from './components/lib-group-input/lib-group-input.component';
import {RaoulComponent} from './components/raoul-component/raoul-component.component';

@NgModule({
  declarations: [LibGroupInputComponent, RaoulComponent],
  imports: [],
  exports: [LibGroupInputComponent, RaoulComponent]
})
export class JarvisUiModule {
}
